(function () {
    "use strict";

    var MODAL_WINDOW_TEMPLATE_URL = "angular/app/modules/common/modals/modal_window_template.html";

    // @ngInject
    function ModalServiceCtor($modal, ModalDialogMappings, $uibModal, Enums) {

        this.$modal = $modal;
        this.$uibModal = $uibModal; // new service
        this.ModalDialogMappings = ModalDialogMappings;
        this.Enums = Enums;
    }


    Services.ModalService = Class(function () {

        return {

            constructor: ModalServiceCtor,

            _openModal: function _openModal(modalInfo, paramsMap, cssClass, closeOnEscapeKey, showBackdrop, enableScroll, useNewModalService) {
                if (!cssClass) {
                    cssClass = '';
                }

                if (typeof closeOnEscapeKey !== 'boolean') {
                    closeOnEscapeKey = true;
                }

                if (typeof showBackdrop !== 'boolean') {
                    showBackdrop = 'static';
                }

                if(enableScroll === true) {
                    cssClass += " reveal-modal--scrollable";
                }

                var resolves = {
                    AppConfigService: 'AppConfigService'
                };

                if (paramsMap) {

                    for (var key in paramsMap) {
                        if (paramsMap[key] === null) {
                            resolves[key] = key;
                        } else {
                            resolves[key] = {
                                injected: paramsMap[key]
                            };
                        }
                    }
                }

                if(!useNewModalService) {
                    return this.$modal.open({

                        templateUrl: modalInfo.template,
                        controller: modalInfo.controller,
                        windowClass: cssClass,
                        resolve: resolves,
                        backdrop: showBackdrop,
                        keyboard: closeOnEscapeKey,
                        backdropRemoveInstant: true
                    });
                } else {

                    return this.$uibModal.open({
                        windowClass: cssClass,
                        openedClass: "hb-modal-open-body-decorator",
                        backdropClass: "hb-modal-backdrop",
                        windowTemplateUrl: MODAL_WINDOW_TEMPLATE_URL,
                        templateUrl: modalInfo.template,
                        controller: modalInfo.controller,
                        bindToController: true,
                        resolve: paramsMap,
                        backdrop: showBackdrop,
                        keyboard: closeOnEscapeKey,
                    });

                }


            },

            _openModalPromise: function _openModalPromise(modalInfo, paramsMap, cssClass, closeOnEscapeKey, showBackdrop, enableScroll, useNewModalService) {
                return this._openModal(modalInfo, paramsMap, cssClass, closeOnEscapeKey, showBackdrop, enableScroll, useNewModalService).result;
            },

            openUploadCoverPhotoModal: function openUploadCoverPhotoModal(company) {
                var model = {
                    instance: company,
                    type: 'cover'
                };
                return this._openModalPromise(this.ModalDialogMappings.Modals.UploadCoverPhoto, {model: model});
            },

            openUploadNewCoverPhotoModal: function openUploadCoverPhotoModal(company) {
                var model = {
                    instance: company,
                    type: 'cover'
                };
                return this.openAttachAssetModal(false, false, true, 'Upload', true, true, null, null, null, true, '', model);
            },

            openUploadVendorPVLFile: function openUploadVendorPVLFile(company) {
                var model = {
                    instance: company,
                    type: 'setup_asset'
                };

                return this.openAttachAssetModal(false,false,true,'Upload',true,true,undefined,undefined,undefined,true,'',model);
            },

            openUploadLogoPhotoModal: function openUploadLogoPhotoModal(company) {
                var model = {
                    instance: company,
                    type: 'logo'
                };
                return this._openModalPromise(this.ModalDialogMappings.Modals.UploadCoverPhoto, {model: model});
            },

            openUploadIdentificationDocumentModal: function openUploadIdentificationDocumentModal(user) {
                var model = {
                    instance: user,
                    type: 'user_identification_doc',
                    forceUploadToS3: true
                };
                return this._openModalPromise(this.ModalDialogMappings.Modals.UploadCoverPhoto, {model: model});
            },

            openUploadIconPhotoModal: function openUploadIconPhotoModal(company, showFooterNote) {
                var model = {
                    instance: company,
                    type: 'icon'
                };

                if (showFooterNote) {
                    model.footerNote = 'UPLOAD_PHOTO._ICON_FOOTER_NOTE_';
                }

                return this._openModalPromise(this.ModalDialogMappings.Modals.UploadCoverPhoto, {model: model});
            },

            openSignatureDialog: function (signatureModel, defaultSignatureFromUser, branded) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.Signature, {signatureModel: signatureModel, defaultSignatureFromUser: defaultSignatureFromUser, branded: branded }, 'signature-modal-container');
            },

            openUploadProfilePhotoModal: function openUploadProfilePhotoModal(user) {
                var model = {
                    instance: user,
                    type: 'profile_image'
                };

                return this._openModalPromise(this.ModalDialogMappings.Modals.UploadCoverPhoto, {model: model});
            },

            openAddImageToMessageModal: function openAddImageToMessageModal(model) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.UploadFiles, {model: model}, 'full-page-modal full-page-modal--white');
            },

            openAddWorkspaceParticipantModal: function openAddWorkspaceParticipantModal(workspace, isNewWorkspace) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.AddWorkspaceParticipant, {
                    workspace: workspace,
                    isNewWorkspace: isNewWorkspace},
                    'hb-modal hb-modal--standard hb-modal--add-contact-modal');
            },

            openAddWorkspaceVendorModal: function openAddWorkspaceVendorModal(workspace, userList) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.AddWorkspaceMember, {workspace: workspace, userList: userList, requestProposal: true, config: this.getAddUserConfig(true),ContactsManager: null});
            },

            openNewVendorReferralModal: function openNewVendorReferralModal(workspace) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.NewVendorReferral, {workspace: workspace, config: this.getAddUserConfig(true)}, 'hb-modal hb-modal--standard hb-modal--add-contact-modal');
            },

            openWorkspaceAdminMoveModal: function openWorkspaceAdminMoveModal(workspace, userList) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.WorkspaceAdminMove, {workspace: workspace, userList: userList, config: this.getAddUserConfig(true)}, 'hb-modal hb-modal--standard hb-modal--add-contact-modal');
            },

            openAssignWorkspaceToTeamMemberModal: function openAssignWorkspaceToTeamMemberModal(workspace, userList, teamMember) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.AssignWorkspaceToTeamMember, {
                    workspace: workspace,
                    userList: userList,
                    teamMember: teamMember
                });
            },

            openAddTeamMemberToWorkspaceModal: function openAddTeamMemberToWorkspaceModal(workspace, userList, canSelectMultiple, isNewWorkspace) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.AddTeamMemberToWorkspace, {workspace: workspace, userList: userList, canSelectMultiple: canSelectMultiple, isNewWorkspace: isNewWorkspace});
            },

            openNewAddContactModal: function openNewAddContactModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.NewAddContact, {}, 'hb-modal hb-modal--standard hb-modal--add-contact-modal');
            },

            newAddPreferredContactModal: function newAddPreferredContactModal(source) {
                var config = this.getAddUserConfig(true);
                config.source = source;
                return this._openModalPromise(this.ModalDialogMappings.Modals.NewAddPreferredContact, {config: config}, 'hb-modal hb-modal--standard hb-modal--add-contact-modal');
            },

            openEditContactModal: function openEditContactModal(user) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.EditContact, { userToEdit: user }, 'hb-modal hb-modal--standard hb-modal--add-contact-modal');
            },


            openNewAddCompanyTeamMemberModal: function openNewAddCompanyTeamMemberModal(company, userList) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.NewAddCompanyTeamMember, {company: company, userList: userList,}, 'hb-modal hb-modal--standard hb-modal--add-contact-modal');
            },

            openCreateEventModal: function openCreateEventModal(config) {
                // date params -> {time: myTime, date: myDate}
                return this._openModalPromise(this.ModalDialogMappings.Modals.CreateEvent, {config: config}, 'hb-modal hb-modal--standard hb-modal--create-project-modal');
            },

            openCreateProjectModal: function openCreateProjectModal(config) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.CreateProject, {config: config}, 'nx-modal create-project-modal', true, true);
            },

            openEmailEditorModal: function openEmailEditorModal(options) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.EmailEditor, {users: options.users, subject: options.subject || "", body: options.body, generalFiles: options.generalFiles || [], imageFiles: options.imageFiles || [], CKEDITOR: null, senderFunction: options.senderFunction, showScheduleOption: options.showScheduleOption, config: options.config || {}, previewFunction: options.previewFunction}, 'email-editor-modal'+ (options.additionalClass ? options.additionalClass : ''));
            },

            openEmailSchedulerModal: function openEmailSchedulerModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ScheduleEmailSend, {}, 'hb-modal hb-modal--standard schedule-email-send-modal', true, true);
            },

            openFileTitleModal: function openFileTitleModal(workspaceFile) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.FileTitleEditor, {workspaceFile: workspaceFile}, 'file-title file-title-modal');
            },

            openBlockConfirmModal: function openBlockConfirmModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.BlockConfirm, {}, 'block block-confirm');
            },

            openFraudStatusReasonModal: function openFraudStatusReasonModal(title, message) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.FraudStatusReason, {title: title, message: message}, 'file-title mark-user-fraud-status-modal', false);
            },

            openClientBotRecapModal: function openClientBotRecapModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ClientBotRecapModal, {}, 'client-bot-recap-modal', true, true);
            },

            openVideoCarouselModal: function openVideoCarouselModal(modalContentType, onConfirm, onCancel) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.VideoCarouselModal, {modalContentType : modalContentType, onConfirmCallback: onConfirm, onCancelCallback: onCancel}, 'video-carousel-modal', true, true);
            },

            openTemplateExamplesModal: function openTemplateExamplesModal(modalContentType, modalContentData, onConfirm, onCancel) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.TemplateExamplesModal, {modalContentType : modalContentType, modalContentData: modalContentData ,onConfirmCallback: onConfirm, onCancelCallback: onCancel}, 'template-examples-modal', true, true);
            },

            openAddPromotionModal: function openAddPromotionModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.AddPromotionModal, {}, 'add-promotion-modal', true, true);
            },

            openContactFormExamplesModal: function openContactFormExamplesModal(modalSource) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ContactFormExamples, {modalSource: modalSource}, 'reveal-modal-full-screen scroll contact-form-examples-modal');
            },

            openContactFormOnMobileModal: function openContactFormOnMobileModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ContactFormOnMobile, {}, 'reveal-modal-full-screen contact-form--mobile');
            },

            openEmbededContactFormModal: function openEmbededContactFormModal(contactFormModel, contactFormParentModel, contactFormState, showOnlyDirectLink) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.EmbededContactForm, {
                    contactFormModel: contactFormModel,
                    contactFormParentModel: contactFormParentModel,
                    contactFormState: contactFormState,
                    showOnlyDirectLink: showOnlyDirectLink
                }, 'cf-embed-modal-container', false);
            },

            openGiftCardDirectLinkModal: function openGiftCardDirectLinkModal(contactFormModel) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.GiftCardPublishModal, {
                    contactFormModel: contactFormModel
                }, 'gift-card-direct-link', false);
            },

            openPreviewContactFormModal: function openPreviewContactFormModal(company, contactForm) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.PreviewContactForm, {company: company,contactForm: contactForm}, 'full-page-modal cf-preview-modal-container__wrapper', false);
            },

            openCoronaChooseTemplateModal: function openCoronaChooseTemplateModal(params) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.CoronaChooseTemplate, {modalParams : params}, 'nx-modal corona-choose-template-modal', true, true);
            },

            openPauseProjectModal: function openPauseProjectModal(projectId, workspaceId) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.PauseProjectModal, {projectId: projectId, workspaceId: workspaceId}, 'nx-modal project-action-modal', false, true);
            },

            openArchiveProjectModal: function openArchiveProjectModal(workspaceId, source) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ArchiveProjectModal, {workspaceId: workspaceId, source: source}, 'nx-modal project-action-modal archive-project-modal', false, true);
            },

            openContactFormMembersModal: function openContactFormMembersModal(contactForm) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ContactFormMembers, {contactForm: contactForm}, 'cf-members-modal__wrapper');
            },

            openAttachAssetModal: function openAttachAssetModal(showCropTab, showGalleryTab, showUploadTab,
                                                                defaultTab, allowMultipleAttach, showBackdrop,
                                                                selectedImage, aspectRatio, showPreviewWhenCropping,
                                                                startUploadFile, acceptFilesFilter, model,
                                                                customCssClass, showCropTitle, footNoteText, branded) {

                var showBackdrop = true;

                var paramsMap = {

                    showCropTab: !showCropTab ? false : true,
                    showGalleryTab: !showGalleryTab ? false : true,
                    showUploadTab: !showUploadTab ? false : true,
                    defaultTab: defaultTab || 'Library',
                    allowMultipleAttach: angular.isUndefined(allowMultipleAttach) ? true : allowMultipleAttach,
                    image: selectedImage ? selectedImage : 'no-image',
                    aspectRatio: aspectRatio || 2.5,
                    assetTypeForUpload: angular.isUndefined(model) ? "" : model.type,
                    showPreviewWhenCropping: angular.isUndefined(showPreviewWhenCropping) ? true : showPreviewWhenCropping,
                    startUploadFile: angular.isUndefined(startUploadFile) ? false : startUploadFile,
                    model: angular.isUndefined(model) ? "no-model" : model,
                    acceptFilesFilter: angular.isUndefined(acceptFilesFilter) ? "" : acceptFilesFilter,
                    customCssClass: "nx-modal nx-modal--full-screen media-modal" + (angular.isUndefined(customCssClass) ? '' : ' ' + customCssClass),
                    showCropTitle: angular.isUndefined(showCropTitle) ? false : showCropTitle,
                    footNoteText: footNoteText,
                    branded: branded
                };

                if (typeof showBackdrop !== 'boolean') {
                    showBackdrop = 'static';
                }


                return this._openModalPromise(this.ModalDialogMappings.Modals.AttachAsset, paramsMap, paramsMap.customCssClass, true, showBackdrop);
            },

            openBlockedVendorModal: function openBlockedVendorModal(vendor) {

                var showBackdrop = true;

                var paramsMap = {
                };

                if (typeof showBackdrop !== 'boolean') {
                    showBackdrop = 'static';
                }

                return this._openModalPromise(this.ModalDialogMappings.Modals.BlockedVendor, {vendor: vendor}, 'reveal-modal-blocked-vendor', true, showBackdrop);
            },


            openCompanyPaymentsModal: function openCompanyPaymentsModal(user) {
                var showBackdrop = true;
                var paramsMap = {
                };

                if (typeof showBackdrop !== 'boolean') {
                    showBackdrop = 'static';
                }

                return this._openModalPromise(this.ModalDialogMappings.Modals.CompanyPayments, {user: user}, 'reveal-modal-company-payments', true, showBackdrop);
            },

            openCompanyPaymentsDetailsModal: function openCompanyPaymentsDetailsModal(file, user_id) {
                var showBackdrop = true;
                var paramsMap = {
                };

                if (typeof showBackdrop !== 'boolean') {
                    showBackdrop = 'static';
                }

                return this._openModalPromise(this.ModalDialogMappings.Modals.CompanyPaymentsDetails, {file: file, user_id: user_id}, 'reveal-modal-company-payments', true, showBackdrop);
            },

            openTemplateSaveAsModal: function openTemplateSaveAsModal(titleWrapper, modalHeader, preventEmptyTitle, onSuccess, onFailure) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.TemplateSaveAs, {
                    titleWrapper: titleWrapper,
                    modalHeader: modalHeader,
                    preventEmptyTitle: preventEmptyTitle,
                    onSuccess: onSuccess,
                    onFailure: onFailure
                }, 'file-title file-title-modal');
            },

            openUnsentFileModal: function openUnsentFileModal(fileType, fileHasPayment) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.UnsentFile, {fileType: fileType, fileHasPayment: fileHasPayment}, 'file-draft-warning-modal');
            },

            openEditPreferredVendorsModal: function openEditPreferredVendorsModal(pvl) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.EditPreferredVendors, {pvl: pvl}, 'full-page-modal pvl-modal');
            },

            openViewPreferredVendorsListModal: function openViewPreferredVendorsListModal(pvl_id, eventId) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ViewPreferredVendorsList, { pvl_id: pvl_id, eventId: eventId }, 'full-page-modal pvl-modal');
            },

            openPVLCreationGuidanceModal: function openPVLCreationGuidanceModal(pvl, eventId) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.PVLCreationGuidanceModal, { pvl: pvl }, 'full-page-modal pvl-creation-guidance-modal');
            },

            openIntroTipModal: function openIntroTipModal() {
                //return this._openModalPromise(this.ModalDialogMappings.Modals.CreateEvent, {});
                //return this._openModalPromise(this.ModalDialogMappings.Modals.IntroTip, {}, 'intro-tip-modal');
                // For now, the intro modal is the mobile app intro modal
                //return this.openMobileAppIntroModal();
                return this.openTopNavIntroModal();
            },

            openMobileAppIntroModal: function openMobileAppIntroModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.MobileAppIntro, {}, 'nx-modal mobile-app-modal');
            },

            getAddUserConfig: function getAddUserConfig(allowSearchContacts){
                return {
                    allowSearchContacts: allowSearchContacts
                };
            },

            /**
             * @param targetState
             * @param options - will be filled with the calendar list when we come back from google authentication flow.
             *      options.googleAccountCalendars
             * @returns {object} - the dialog's promise
             */
            openConnectCalendarModal: function openConnectCalendarModal(options) {
                var optionsInternal = {
                    isConnected: !!options.isConnected,
                    commingFromGoogleAuth: options && options.commingFromGoogleAuth ? options.commingFromGoogleAuth : false,
                    googleCalendarProvider: options && options.googleCalendarProvider ? options.googleCalendarProvider : null
                };
                return this._openModalPromise(this.ModalDialogMappings.Modals.ConnectCalendarModal, {options: optionsInternal}, 'nx-modal connect-calendar-modal');
            },

            openWorkspaceTypeIntroModal: function openWorkspaceTypeIntroModal(workspace) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.WorkspaceTypeIntro, {workspace: workspace});
            },

            openExpandImageModal: function openExpandImageModal(serviceModel, isEditMode) {
                //return this._openModalPromise(this.ModalDialogMappings.Modals.CreateEvent, {});
                return this._openModalPromise(this.ModalDialogMappings.Modals.ExpandImage, {serviceModel: serviceModel, isEditMode: isEditMode}, 'expand-image-modal');
            },

            openWelcomeVideoModal: function openWelcomeVideoModal(openSource) {
                var videoOptions = {
                    modalOpenSource: openSource,
                    videoTitle: "Welcome Video",
                    videoLink: "https://player.vimeo.com/video/154378323?autoplay=1"
                };

                return this.openGenericVideoModal(videoOptions);
            },

            openTomCruiseVideoModal: function openTomCruiseVideoModal(openSource) {
                var videoOptions = {
                    modalOpenSource: openSource,
                    videoTitle: "Your Session with Tom Cruz",
                    videoLink: "https://player.vimeo.com/video/393691169?autoplay=1"
                };

                return this.openGenericVideoModal(videoOptions);
            },

            openGenericVideoModal: function openGenericVideoModal(options) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.GenericVideo, {
                    modalOpenSource: options.modalOpenSource,
                    videoTitle: options.videoTitle,
                    videoLink: options.videoLink,
                    modalTitle: options.modalTitle,
                    modalSubTitle: options.modalSubTitle,
                    modalBtnText: options.modalBtnText,
                    modalBtnOnClickFunc: options.modalBtnOnClickFunc,
                    videoId: options.videoId,
                    enableYoutubeApi: options.enableYoutubeApi,
                    analyticsName: options.analyticsName,
                }, 'video-modal ' + options.additionalCssClasses, true, false);
            },

            openBrochureVideoModal: function openBrochureVideoModal(openSource){
                return this._openModalPromise(this.ModalDialogMappings.Modals.BrochureVideo, {modalOpenSource: openSource}, 'brochure-video-modal', true);
            },

            openTOSModal: function openWTOSModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.TOS, '', true);
            },
            openTOSChangedModal: function openTOSChangedModal(text) {

                var data = {
                    text: text
                };
                return this._openModalPromise(this.ModalDialogMappings.Modals.TOSChanged, data, 'tos-changed-modal', false);
            },
            openSentFirstOnboardingFile: function openSentFirstOnboardingFile(workspaceFile){
                var data = {
                    workspaceId: workspaceFile.couple_card_id,
                    eventId: workspaceFile.event._id,
                    fileType: workspaceFile.file_type
                };
                return this._openModalPromise(this.ModalDialogMappings.Modals.SentFirstOnboardingFile, data, 'first-sent-onboarding-file-modal', false);
            },
            openDisableAutoPayModal: function openDisableAutoPayModal(workspaceFile) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.DisableAutoPay, {workspaceFile: workspaceFile}, 'small-modal disable-auto-pay-modal', true);
            },
            openConfirmAutoPayModal: function openConfirmAutoPayModal(ach){
                return this._openModalPromise(this.ModalDialogMappings.Modals.ConfirmAutoPay, {ach: ach}, 'small-modal confirm-auto-pay-modal', true);
            },

            openTrialExpiringModal: function openTrialExpiringModal(trialExpiredOnNewSession){
                return this._openModalPromise(this.ModalDialogMappings.Modals.TrialExpiringModal, {trialExpiredOnNewSession: trialExpiredOnNewSession}, 'hb-modal hb-modal--standard hb-modal--trial-expiring', false);
            },

            openTrialExtendedModal: function openTrialExtendedModal(extensionLength){
                return this._openModalPromise(this.ModalDialogMappings.Modals.TrialExtendedModal, {extensionLength: extensionLength}, 'trial-extended-modal', true, true);
            },

            openPipelineSettingsModal: function openPipelineSettingsModal(currentUserCompany) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.PipelineSettings, {currentUserCompany: currentUserCompany},
                    'full-page-modal full pipeline-settings-modal', true, false);
            },

            openConfirmDeleteStageModal: function openConfirmDeleteStageModal(stageToMoveWorkspacesTo){
                return this._openModalPromise(this.ModalDialogMappings.Modals.ConfirmDeleteStage, {stageToMoveWorkspacesTo: stageToMoveWorkspacesTo}, 'small-modal confirm-delete-stage-modal', true);
            },

//            openPipelineSettingsIntroModal: function openPipelineSettingsIntroModal(){NOT SHOWING PIPELINE INTRO MODAL FOR NOW
//                return this._openModalPromise(this.ModalDialogMappings.Modals.PipelineSettingsIntro, {}, 'pipeline-settings-intro-modal', true);
//            },

            openConfirmBrochureSelectionModal: function openConfirmBrochureSelectionModal(companyName) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ConfirmBrochureSelection, {companyName: companyName}, 'small-modal', true);
            },

            openSendBrochureWarningModal: function openSendBrochureWarningModal(title) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.SendBrochureWarning, {title: title}, 'small-modal', true);
            },

            //not in use :(
            openCreateExampleProposalModal: function openCreateExampleProposalModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.CreateExampleProposal, null, 'small-modal', true);
            },

            openChangeSubscriptionModal: function openChangeSubscriptionModal(paymentMethod, currentPlan, price, isDiscounted) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ChangeSubscription, {paymentMethod: paymentMethod, currentPlan: currentPlan, price: price, isDiscounted: isDiscounted}, 'change-subscription reveal-modal-full-screen', true, false);
            },

            openPipelineSendBrochureModal: function openPipelineSendBrochureModal(workspace) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.PipelineSendBrochure, {workspace: workspace}, 'pipeline-send-brochure');
            },

            /**
             * @param {object} options the options object
             * @param {object} options.isCreateMeeting - open the dialog in creation mode, false means in editing mode
             * @param {moment} options.dateTimeStart - this is valid in creation mode and indicate the start time that was selected, date and time if exists (day, week view selection)
             * @param {object} options.calendarItemModel - this is valid only in editing mode. the calendarItem model
             * @param {string} options.viewType - the view type in which we are creating this meeting. this will effect how we auto populate the start time and end time
             *                                    it could be one of the following view type of the fullcalendar: month,agendaWeek,agendaDay
             * @returns {promise}
             */
            openCalendarMeetingModal: function openCreateMeetingModal(options) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.CalendarMeetingModal, {options: options}, 'nx-modal schedule-meeting-modal', false, true);
            },

            openRescheduleModal: function openRescheduleModal(projectId, workspaceId, isUnpause, source) {
              return this._openModalPromise(this.ModalDialogMappings.Modals.RescheduleProjectContainerModal, {projectId: projectId, workspaceId: workspaceId, isUnpause: isUnpause, source: source}, 'nx-modal project-action-modal reschedule-project', false, true);
            },

            openMoveStageModal: function openMoveStageModal(workspace, company) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.MoveStageProjectModal, {workspace: workspace, company: company}, 'nx-modal project-action-modal', false, true);
            },

            openNewTagVendorModal: function openNewTagVendorModal(project) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.NewNetworkTagVendor, {project: project}, 'hb-modal hb-modal--standard hb-modal--add-contact-modal');
            },

            openNetworkHelloLinkModal: function openNetworkHelloLinkModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.NetworkHelloLinkModal, {}, 'network-workflow-link-modal', false);
            },

            openVenuesUpgradeNowModal: function openVenuesUpgradeNowModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.VenuesUpgradeNowModal, {}, 'venues-upgrade-now-modal', false);
            },

            openNetworkOnboardingIntroductionModal: function openNetworkOnboardingIntroductionModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.NetworkOnboardingIntroductionModal, {}, 'network-onboarding-introduction-modal', false);
            },

            openCreateOpportunityModal: function openCreateOpportunityModal(params) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.CreateOpportunityModal, {modalParams : params}, 'hb-modal hb-modal--standard create-opportunity-modal', true, true);
            },

            openFacebookLeadsIntroModal: function openFacebookLeadsIntroModal(params) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.FacebookLeadsIntroModal, {modalParams : params}, 'hb-modal facebook-leads-intro-modal', true, true);
            },

            openFacebookLeadsModal: function openFacebookLeadsModal(params) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.FacebookLeadsModal, {modalParams : params}, 'hb-modal hb-modal--standard add-facebook-page-modal', true, true);
            },

            openEditOpportunityModal: function openEditOpportunityModal(params) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.EditOpportunityModal, {modalParams: params}, 'hb-modal hb-modal--standard create-opportunity-modal', true, true);
            },

            openInviteNetworkUserModal: function openInviteNetworkUserModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.NewNetworkInviteUser, {config: this.getAddUserConfig(true)}, 'hb-modal hb-modal--standard hb-modal--add-contact-modal');
            },

            openWelcomeLeadModal: function openWelcomeLeadModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.WelcomeLeadModal, {}, 'full-page-modal welcome-lead-modal', true, false);
            },

            openPvlRecommendationsModal: function openPvlRecommendationsModal(workspace) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.PvlRecommendationsModal, {workspace: workspace}, 'full-page-modal pvl-request-modal', true, false);
            },

            openNetworkImproveProfileModal: function openNetworkImproveProfileModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.NetworkImproveProfileModal, {}, 'network-improve-profile-modal', false);
            },

            openPvlInquiryVendorsModal: function openPvlInquiryVendorsModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.PvlInquiryVendorsModal, {}, 'pvl-inquiry-vendors-modal', false);
            },

            openEventSpaces: function openEventSpaces(event, isNewEvent) {
                var cssClass = isNewEvent ? 'event-spaces-modal' : 'event-spaces-modal-edit';
                return this._openModalPromise(this.ModalDialogMappings.Modals.EventSpacesModal, {
                    event: event,
                    isNewEvent: isNewEvent
                }, 'nx-modal ' + cssClass, false);

            },

            openIntakeModal: function openIntakeModal(intakeVersion) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.IntakeModal, {intakeVersion:intakeVersion}, 'modal--standard intake-modal', true, true);
            },

            openMalkutBankOwnerDetailsModal: function openMalkutBankOwnerDetailsModal(user, person) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.MalkutBankOwnerDetailsModal, {user: user, person: person}, 'nx-modal malkut-bank-account__owner-modal bank-account__form-modal', true, true);
            },

            openMalkutTransferFundsFromHbModal: function openMalkutTransferFundsFromHbModal(email, company_id) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.MalkutTransferFundsFromHBModal, {email: email, company_id: company_id}, 'malkut-tranfer-funds', true, true);
            },

            openMalkutPullFundsFromMemberBankModal: function openMalkutPullFundsFromMemberBankModal(email, company_id, allow_enter_managed_account_id) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.MalkutPullFundsFromMemberBankModal, {email: email, company_id: company_id, allow_enter_managed_account_id: allow_enter_managed_account_id}, 'malkut-tranfer-funds', true, true);
            },

            openMalkutBankAccountInfoModal: function openMalkutBankAccountInfoModal(email, company_id) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.MalkutBankAccountInfoModal, {email: email, company_id: company_id}, 'malkut-manage-bank-account', true, true);
            },

            openMalkutDisputedPaymentModal: function openMalkutDisputedPaymentModal(payment) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.MalkutDisputedPaymentModal, {payment: payment}, 'malkut-manage-bank-account', true, true);
            },

            openAddMalkutUserModal: function openAddMalkutUserModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.AddMalkutUserModal, {}, 'modal', true, true);
            },

            openLeadSourceModal: function openLeadSourceModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.leadSourceModal, {}, 'lead-source-modal');
            },

            openBadgeCodeModal: function openBadgeCodeModal(badgeCode, badgeUser) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.BadgeCodeModal, {
                    badgeCode: badgeCode,
                    badgeUser: badgeUser
                }, 'badge-modal');
            },

            openMalkutCreateCustomPricingPlanModal: function openMalkutCreateCustomPricingPlanModal(company) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.MalkutCustomPricingPlan, {company: company}, 'malkut-custom-pricing-plan-modal', true, true);
            },

            openTopNavIntroModal: function openTopNavIntroModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.TopNavIntro, {}, 'intro-tip-modal top-nav-intro-modal');
            },

            openSendBatchEmailModal: function openSendBatchEmail(onSuccessFunction) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.SendBatchEmails, {onSuccessFunction: onSuccessFunction}, 'reveal-modal-full-screen batch-emails-modal-outer');
            },

            openReferralModal: function openReferralModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ReferralModal, {}, 'referralModal', true, true);
            },

            openLoginAsClientModal: function openLoginAsClientModal(client, workspaceFileId) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.LoginAsClientModal, {client: client, workspaceFileId: workspaceFileId}, 'login-as-client-modal');
            },

            openAddWorkflowModal: function openAddWorkflowModal(workspace) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.AddWorkflowWorkflowModal, { workspace: workspace}, 'workflow-modal full-page-modal', false);
            },

            openfullviewWorkflowModal: function openfullviewWorkflowModal(workspace, workflowId) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.FullviewWorkflowWorkspace, { workspace: workspace, workflowId: workflowId}, 'workflow-instance full-page-modal', false);
            },

            openConfirmPremiumFeature: function openConfirmPremiumFeature() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ConfirmPremiumFeature, {}, 'small-modal confirm-premium-feature');
            },

            openConfirmGmailIntegrationNeeded: function openConfirmGmailIntegrationNeeded() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ConfirmGmailIntegrationNeeded, {}, 'small-modal confirm-gmail-integration-needed');
            },

            openPayWallModal: function openPayWallModal(pricingPlan) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.PayWallModal, {pricingPlan: pricingPlan}, 'pay-wall-modal full-page-modal', false);
            },

            openTwoFactorAuthModal: function openTwoFactorAuthModal(shouldVerify) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.TwoFactorAuth, { shouldVerify: shouldVerify }, 'two-factor-auth-modal full-page-modal', false);
            },

            openGoogleContactsModal: function openGoogleContactsModal(onUserClicked, addContactCta, selectVendorType, filterExistingContacts, originState, analyticsEventValue) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.GoogleContactsModal, {onUserClicked: onUserClicked, addContactCta: addContactCta, selectVendorType: selectVendorType, filterExistingContacts: filterExistingContacts, originState: originState, analyticsEventValue: analyticsEventValue}, 'googleContactsModal', true);
            },

            openNonUsaWarningModal: function openNonUsaWarningModal(clickSource) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.NonUsaWarningModal, {clickSource:clickSource}, 'non-us-resident-modal non-us-internal-modal', false);
            },

            openCreateManualReferralModal: function openCreateManualReferralModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.CreateManualReferralModal, {}, '', false);
            },

            openUpdateReferralCodeModal: function openUpdateReferralCodeModal(user) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.UpdateReferralCodeModal, {user: user}, '', false);
            },

            openUpdateContactFormUrlModal: function openUpdateContactFormUrlModal(user) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.UpdateContactFormUrlModal, {user: user}, '', false);
            },

            ConfirmFileExpirationModal: function openConfirmDeleteStageModal(){
                return this._openModalPromise(this.ModalDialogMappings.Modals.ConfirmFileExpiration, null, 'small-modal confirm-file-expiration-modal', true);
            },

            openArchiveReasonsModal: function openArchiveReasonsModal(workspace, reasons, handleArchiveReason) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ArchiveReasonsModal, {workspace: workspace, reasons: reasons, handleArchiveReason: handleArchiveReason}, 'archive-reasons-modal', false);
            },

            openProjectDetailsModal: function openProjectDetailsModal(eventId) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ProjectDetailsModal, {eventId: eventId}, 'hb-modal hb-modal--standard project-details-modal', true, true, true);
                //return this._openModalPromise(this.ModalDialogMappings.Modals.ProjectDetailsModal, {eventId: eventId}, 'nx-modal project-details-modal', true, true, false, true);
            },

            openOfferLoanModal: function openOfferLoanModal(data) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.OfferLoanModal, {
                    fileId: data._id,
                    fileTitle: data.file_title,
                    projectName: data.project_name,
                    loanAmount: data.loan_amount,
                    netLoanAmount: data.net_loan_amount,
                    loanDueDate: data.loan_due_date,
                    interestFee: data.interest_fee,
                }, 'loan-modal', true);
            },

            openCalendlyAddApiKeyModal: function openCalendlyAddApiKeyModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.CalendlyAddApiKeyModal, {}, 'calendly-connect-api-key-modal', true);
            },

            openCalendlyDisconnectModal: function openCalendlyDisconnectModal(){
                return this._openModalPromise(this.ModalDialogMappings.Modals.CalendlyDisconnectModal, {}, 'calendly-disconnect-modal', true);
            },

            openWorkspaceParticipantModal: function openWorkspaceParticipantModal(participant, workspace, allowActions) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.WorkspaceParticipantModal, {participant: participant, workspace: workspace, allowActions: allowActions}, 'participant-modal', true);
            },

            openMessagePopupModal: function openMessagePopupModal(popupData) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.MessagePopupModal, { popupData: popupData }, 'hb-popup-window ' + popupData.cssClass, popupData.popupInfo.closeOnEsc, popupData.popupInfo.showBackdrop, null, true);
            },

            openConnectProjectModal: function openConnectProjectModal(options) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ConnectProjectModal, {options: options},'nx-modal connect-project-modal', false, true);
            },

            openMwebConnectProjectModal: function openMwebConnectProjectModal(options) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.mWebConnectProjectModal, {options: options}, 'nx-modal connect-project-modal', false);
            },

            openTimeTrackerSampleModal: function openTimeTrackerSampleModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.TimeTrackerSampleModal, {}, 'time-tracker-sample-modal', true, true);
            },

            openTimeTrackerEntryModal: function openTimeTrackerEntryModal(projectId, timeTrackerEntry, source) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.TimeTrackerEntryModal, {projectId: projectId, timeTrackerEntry: timeTrackerEntry, source: source}, 'time-tracker-modal', true);
            },

            openTimeTrackerViewAllModal: function openTimeTrackerViewAllModal(workspace, viewState, project) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.TimeTrackerViewAllModal, {workspace: workspace, viewState: viewState, project: project}, 'time-tracker-modal-all full-page-modal', false);
            },

            openTimeTrackerToolInvoiceModal: function openTimeTrackerToolInvoiceModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.TimeTrackerToolInvoiceModal, {}, 'time-tracker-tool-invoice', false);
            },

            openCreateFirstProjectModal: function openCreateFirstProjectModal(showCreateProject) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.openCreateFirstProjectModal, {showCreateProject: showCreateProject}, 'hb-popup-window create-first-project-modal', false, true);
            },

            openMalkutUpdateCompanyLocationModal: function openMalkutUpdateCompanyLocationModal(company) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.MalkutUpdateCompanyLocation, {company: company}, 'hb-modal hb-modal--standard update-company-location', false);
            },

            openMalkutInjectTemplatesModal: function openMalkutInjectTemplatesModal(destCompanyUser, destCompany) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.MalkutInjectTemplatesToCompany, {destCompanyUser: destCompanyUser, destCompany: destCompany}, 'hb-modal hb-modal--standard inject-templates-modal', false);
            },

            openMalkutInjectCoronaTemplatesModal: function openMalkutInjectCoronaTemplatesModal(originCompanyUser, originCompany) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.MalkutInjectCoronaTemplatesToBatch, {originCompanyUser: originCompanyUser, originCompany: originCompany}, 'hb-modal hb-modal--standard inject-templates-modal', false);
            },

            openMalkutSelectTemplatesForPromoModal: function openMalkutSelectTemplatesForPromoModal(educator) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.MalkutSelectTemplatesForPromo, {educator: educator}, 'hb-modal hb-modal--standard inject-templates-modal', false);
            },

            openDoneInvoiceOnboardingModal: function openDoneInvoiceOnboardingModal(workspace, workspaceFile) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.DoneInvoiceOnboardingModal, {workspace: workspace, workspaceFile: workspaceFile}, 'hb-modal hb-modal--standard done-invoice-onboarding-modal', true, true);
            },

            openStartFromFileWizardModal: function openStartFromFileWizardModal(fileType, workspace) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.StartFromFileWizardModal,
                    {fileType: fileType, workspace: workspace}, 'hb-modal hb-modal--standard start-from-file-wizard-modal', true, true);
            },

            openBadgePillTypesModal: function openBadgePillTypesModal(collection, onSaveHandler, limit, collectionType, modalTitle, analyticsArgs, modalDescription) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.BadgePillTypesModal, {
                    badgePillType: collectionType,
                    badgePillCollection: collection,
                    onSaveHandler: onSaveHandler,
                    limit: limit,
                    modalTitle: modalTitle,
                    analyticsArgs: analyticsArgs,
                    modalDescription: modalDescription
                }, 'nx-modal hb-modal--standard edit-tags-modal', true);
            },

            openEditLeadSourceModal: function openEditLeadSourceModal(collection, onSaveHandler, analyticsArgs) {
                return this.openBadgePillTypesModal(collection, onSaveHandler, 18, this.Enums.badgePillTypes.lead_sources, 'PROJECT.LEADSOURCE.LABELS._MODAL_EDIT_LEAD_SOURCE_', analyticsArgs, 'PROJECT.LEADSOURCE.LABELS._MODAL_EDIT_LEAD_SOURCE_DESCRIPTION_');
            },

            openEditProjectTypesModal: function openEditProjectTypesModal(collection, onSaveHandler, analyticsArgs) {
                return this.openBadgePillTypesModal(collection, onSaveHandler, 18, this.Enums.badgePillTypes.project_types, 'PROJECT.LEADSOURCE.LABELS._MODAL_EDIT_PROJECT_TYPES_', analyticsArgs);
            },

            openEditSpacesModal: function openEditSpacesModal(collection, onSaveHandler, analyticsArgs) {
                return this.openBadgePillTypesModal(collection, onSaveHandler, 18, this.Enums.badgePillTypes.company_spaces, 'PROJECT.LEADSOURCE.LABELS._MODAL_EDIT_SPACES_', analyticsArgs);
            },

            openThankYouReferralModal: function openThankYouReferralModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ThankYouReferralModal,
                    {}, 'hb-modal hb-modal--standard thank-you-referral-modal', true, true);
            },

            openMarkAsPaidModal: function openMarkAsPaidModal(payment) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.MarkAsPaidModal, {payment: payment}, 'hb-modal hb-modal--standard mark-as-paid-modal', true, true);
            },

            openRefundPaymentModal: function openRefundPaymentModal(payment, fileId, isUndoMap) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.RefundPaymentModal, {payment: payment, workspaceFileId: fileId, isUndoMap: isUndoMap}, 'nx-modal refund-modal', true, true);
            },

            openAddDebitCardModal: function openAddDebitCardModal(source) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.DebitCardModal, {source: source}, 'nx-modal debit-card-modal', true, true);
            },

            openInstantDepositModal: function openInstantDepositModal(source, workspaceFileId, invoiceId) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.InstantDepositModal, {source: source, workspaceFileId: workspaceFileId, invoiceId: invoiceId}, 'nx-modal instant-deposit-modal', true, true);
            },

            openCreditCardConfirmModal: function openCreditCardConfirmModal(card) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.CreditCardConfirm, {card: card}, 'nx-modal credit-card-confirm__modal', true, true);
            },

            openApproveReferralCommissionModal: function openApproveReferralCommissionModal(referral, pendingCommissionReferrals) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ApproveReferralCommissionModal, {referral: referral, pendingCommissionReferrals: pendingCommissionReferrals}, 'hb-modal hb-modal--standard malkut-approve-referral-commissions-modal', true, true);
            },

            openBrandingInspirationModal: function openBrandingInspirationModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.BrandingInspirationModal, {}, 'nx-modal branding-inspiration__modal', true, true);
            },

            openUploadClientsModal: function openUploadClientsModal(startFromStep) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.UploadClientsModal, {startFromStep: startFromStep}, 'nx-modal nx-modal--full-screen upload-clients__modal', true, true);
            },
            openClientFlowModal: function openClientFlowModal(fileType) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ClientFlowModal, {fileType: fileType}, 'nx-modal client-flow-modal', true, true);
            },

            openContactFormExplantionVideoModal: function openContactFormExplantionVideoModal(fileType) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ContactFormExplanationVideoModal, {fileType: fileType}, 'nx-modal cf-explain', true, true);
            },

            openAddCompanyModal: function openAddCompanyModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.AddCompanyModal, {}, 'nx-modal add-company-modal', true, true);
            },

            openBrochureSectionsModal: function openBrochureSectionsModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.BrochureSectionsModal, {}, 'nx-modal nx-modal--full-screen', true, true);
            },

            openClientPortalSendLinkModal: function openSendLinkClientPortal(workspaceClients, clientPortalUrl) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ClientPortalSendLink, {workspaceClients: workspaceClients, clientPortalUrl: clientPortalUrl}, 'nx-modal client-portal__send-link-modal', true, true);
            },

            openClientPortalDemoModal: function openClientPortalDemoModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ClientPortalDemo, {}, 'nx-modal client-portal__demo-modal', true, true);
            },

            openPipelineOnboardingModal: function openPipelineOnboardingModal(options) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.PipelineOnboardingModal, {}, 'nx-modal nx-modal--full-screen pipeline-onboarding-container', true, false);
            },

            openPendingActionModal: function openPendingActionModal(promise, workspaces, title, failedTitle, failedText, positiveBtnText, analyticsActionName, successCallback) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.PendingActionModal, {promise: promise, workspaces: workspaces, title: title, failedTitle: failedTitle, failedText: failedText, positiveBtnText: positiveBtnText, analyticsActionName: analyticsActionName, successCallback: successCallback}, 'nx-modal pending-action-modal', false, true);
            },

            openCustomUrlModal: function openCustomUrlModal(icon, title, text, positiveBtnText) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.CustomUrlModal, {icon: icon, title: title, text: text, positiveBtnText: positiveBtnText}, 'nx-modal custom-url-modal', true, true);
            },
            openConfirmLoanBankAccountModal: function openConfirmLoanBankAccountModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ConfirmLoanBankAccountModal, {}, 'nx-modal confirm-loan-bank-account-modal', true, true);
            },

            openEditPaymentReminderEmailModal: function openEditPaymentReminderEmailModal(paymentReminder) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.EditPaymentReminderEmailModal, {paymentReminder: paymentReminder}, 'nx-modal edit-payment-reminder-email-modal', false, true);
            },

            openConnectBankAccountModal: function openConnectBankAccountModal(src, step, isMultiSelect, props) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ConnectBankAccount, {src: src, step: step, isMultiSelect: isMultiSelect, props: props}, 'nx-modal connect-bank-account-modal', true, true);
            },

            openChoosePlaidSubAccountModel: function openChoosePlaidSubAccountModel(bankData) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ChoosePlaidSubAccountModal, {bankData: bankData}, 'nx-modal choose-plaid-sub-account-modal', true, true);
            },


            openProjectDetailsNotesModal: function openProjectDetailsNotesModal(project, company) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ProjectDetailsNotesModal, {project:project, company:company}, 'nx-modal nx-modal--full-screen project-details__notes__modal', true, false);
            },

            openBirthdayModal: function openBirthdayModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.BirthdayModal, {}, 'nx-modal happy-birthday-modal', true, true);
            },

            openProjectDetailsCustomizeModal: function openProjectDetailsCustomizeModal(company) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.ProjectDetailsCustomizeModal, {customizeFields: company.custom_project_fields, company: company}, 'nx-modal project-details__customize-modal', true, true);
            },

            openInteractiveOnboardingExplainBrandingModal: function openInteractiveOnboardingExplainBrandingModal(fileData) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.InteractiveOnboardingExplainBrandingModal, { fileData: fileData }, 'nx-modal int-onb-explain-branding', true, true);
            },

            openInteractiveOnboardingExplainServicesModal: function openInteractiveOnboardingExplainServicesModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.InteractiveOnboardingExplainServicesModal, {}, 'nx-modal int-onb-explain-services', true, true);
            },

            openAddBankAccountOwnerModal: function openAddBankAccountOwnerModal(person, fromBankAccountForm) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.AddBankAccountOwnerModal, {person: person, fromBankAccountForm: fromBankAccountForm}, 'nx-modal bank-account__owner-modal bank-account__form-modal', true, true);
            },

            openBankAccountBusinessInfoModal: function openBankAccountBusinessInfoModal(bankAccountType) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.BankAccountBusinessInfo, {bankAccountType: bankAccountType}, 'nx-modal bank-account__business-info-modal bank-account__form-modal', true, true);
            },

            openMwebBlockModal: function openMwebBlockModal() {
                return this._openModalPromise(this.ModalDialogMappings.Modals.MwebBlockModal, {}, 'nx-modal mweb-block-modal', false, true);
            },

            openBulkCreatePromoCodesModal: function openBulkCreatePromoCodesModal(pricingPlansHash, pricingPlanIdToTitle) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.BulkCreatePromoCodesModal, {pricingPlansHash: pricingPlansHash, pricingPlanIdToTitle: pricingPlanIdToTitle}, 'nx-modal malkut-bulk-create-promo-modal', true);
            },

            openEditDayAvailabilityModal: function openEditDayAvailabilityModal(session, dayAvailability, date, addTimeRangeOpen) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.EditDayAvailabilityModal, {session: session, dayAvailability: dayAvailability, date: date, addTimeRangeOpen: addTimeRangeOpen}, 'nx-modal edit-day-availability-modal', false, true);
            },

            openCreatedSessionModal: function openCreatedSessionModal(session, company) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.CreatedSessionModal, { session: session, company: company, }, 'nx-modal created-session-modal', true, true);
            },

            openTemplatesExplainModal: function openTemplatesExplainModal(isReturnUser) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.TemplatesExplainModal, { isReturnUser: isReturnUser }, 'nx-modal templates-explain-modal');
            },

            openBulkEmailsIntroModal: function openBulkEmailsIntroModal(batchSource) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.BulkEmailsIntroModal, {batchSource: batchSource}, 'nx-modal bulk-emails-intro-modal', true, true);
            },

            openEmailTemplatesModal: function openEmailTemplatesModal(selectedWorkspacesIds) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.EmailTemplatesModal, {}, 'nx-modal email-templates-modal', true, true);
            },

            openVerifyBillingInfoModal: function openVerifyBillingInfoModal(account) {
                return this._openModalPromise(this.ModalDialogMappings.Modals.VerifyBillingInfoModal, {account: account}, 'nx-modal bulk-emails-intro-modal', true, true);
            },
        };
    });
}());
